import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import IconArrow from 'src/assets/images/icons/arrow-left_ico.svg';
import Button from 'src/presentations/components/atom/button';
import { useFormContext } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { useTourContext } from 'src/presentations/guided-tours';
import { FilterHeader } from '../filter/FilterHeader';
import { FilterDrawer } from '../analytics/filter/FilterDrawer';
import { filterAccordionsMapper } from '../analytics/analyticsMapper';
import { SavePerformanceReportModal } from './SavePerformanceReportModal';
import { RhfFieldInfo } from '../analytics/filter/RhfFieldInfo';
import { IPerformanceStateProps } from './types';

interface PerformanceTopContentProps {
  dataFilter: Record<string, any>;
  hashedFilter: IPerformanceStateProps;
  allowedCurrencies?: string[];
  isLoading?: boolean;
}

export const PerformanceTopContent = ({ dataFilter, hashedFilter, allowedCurrencies, isLoading }: PerformanceTopContentProps) => {
  const { watch } = useFormContext();
  const [isShowModal, setIsShowModal] = useState(false);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  // Removed unused state variables
  const formValues = watch();
  const navigate = useNavigate();
  const tour = useTourContext().appTour.registerTour('performanceAssessment');
  const filterAccordions = filterAccordionsMapper(dataFilter);

  return isLoading ? (
    <div className='flex items-center justify-center'>
      <CircularProgress color='primary' />
    </div>
  ) : (
    <div className='flex items-center gap-16 xl:gap-24 py-20 xl:py-24 px-16 xl:px-32'>
      <div id={tour.registerStep('performanceAssessmentPage')} className='flex items-center gap-12 xl:gap-18'>
        <button
          onClick={() => {
            // Get the stored section from localStorage or default to PERFORMANCE
            const sectionName = localStorage.getItem('lastSectionName') || 'PERFORMANCE';
            navigate(`/?section=${sectionName}`);
          }}
          className='w-40 h-40 rounded-full bg-neutral-10 border border-neutral-20 transition-all duration-300 hover:border-neutral-40 flex items-center justify-center cursor-pointer'
        >
          <img src={IconArrow} alt='Back' />
        </button>
        <div className='flex flex-col gap-4'>
          <RhfFieldInfo fieldName='name' defaultValue={hashedFilter.name} infoClassname='text-18 xl:text-24 font-bold text-blue_grey-80' />

          <RhfFieldInfo
            fieldName='description'
            defaultValue={hashedFilter.description}
            textSize='md'
            infoClassname='text-12 xl:text-14 font-medium text-neutral-60'
          />
        </div>
      </div>
      <div className='ml-auto flex items-center gap-12 xl:gap-16'>
        <Button variant='primary' size='medium' className='!min-w-0 !h-36' onClick={() => setIsShowModal(true)}>
          Save Report
        </Button>
        <div className='w-1 h-16 bg-neutral-20' />
        <FilterHeader onChangeFilter={() => {}} allowedCurrencies={allowedCurrencies} />
        <FilterDrawer filterAccordions={filterAccordions} isOpen={isFilterDrawerOpen} setIsOpen={setIsFilterDrawerOpen} />
      </div>
      {/* Save Report Modal */}
      <SavePerformanceReportModal open={isShowModal} onClose={() => setIsShowModal(false)} dataFilter={dataFilter} />
    </div>
  );
};
